module.exports = __webpack_public_path__ + "img/category.a7c4f200.svg";